<template>
  <layout :user="$store.state.user" :menu="menu" @logout="logout">
    <h4 slot="page-title">{{pageTitle}}</h4>
    <breadcrumb slot="breadcrumb" :routes="$route.matched"></breadcrumb>

    <modal v-if="shouldRefresh">
      <h4>Votre session est expirée !</h4>
      <p>Réactualisez la page et reconnectez-vous pour continuer...</p>
      <button class="btn btn-warning" @click="refreshBrowser">Actualiser la page</button>
    </modal>

    <notification v-for="notification in $store.state.notifications" :key="notification.id"
                  @close="removeNotification(notification)" :type="notification.type"
                  :title="notification.title" :icon="notification.icon" v-html="notification.text" />

    <router-view></router-view>
  </layout>
</template>

<script>
  import gql from 'graphql-tag';
  import {AppMixin} from '../mixins/app-mixin';
  import Layout from 'package-common-vuejs/src/layouts/StandardLayout';
  import Modal from 'package-common-vuejs/src/components/Modal';
  import Notification from 'package-common-vuejs/src/components/Notification';
  import Breadcrumb from 'package-common-vuejs/src/components/Breadcrumb';

  export default {
    mixins: [AppMixin],
    components: {
      Breadcrumb,
      Layout,
      Modal,
      Notification,
    },
    data() {
      return {
        shouldRefresh: false,
      };
    },
    props: {
      menu: Array,
    },
    apollo: {
      user: {
        query: gql`query {
          user: userInfo { id name isAdmin permissions }
        }`,
        fetchPolicy: 'network-only',
        result({data: {user}}) {
          this.$store.dispatch('setUser', user);
        },
        manual: true,
      },
    },
    computed: {
      pageTitle() {
        return (this.$route.meta && this.$route.meta.title) || this.$route.name;
      },
    },
    created() {
      this.triggerRefresh();
    },
    methods: {
      /**
       * Trigger refresh right before expiration date
       */
      async triggerRefresh() {
        const DELAY_BEFORE_REFRESH = 5000; // 5 sec before expiration
        const refreshToken = localStorage.getItem('refresh_token');
        const expiresAt = Number(localStorage.getItem('expires_at'));
        const currentTime = (new Date()).getTime();
        const delay = expiresAt - currentTime - DELAY_BEFORE_REFRESH;
        if (refreshToken && expiresAt && delay > 0) { // Refresh auth_token
          window.setTimeout(this.refresh.bind(this), expiresAt - currentTime - DELAY_BEFORE_REFRESH);
        } else {
          this.shouldRefresh = true;
        }
      },
      /**
       * Use the refresh token to re-auth the user
       */
      async refresh() {
        console.log('Refreshing token...');
        const refreshToken = localStorage.getItem('refresh_token');
        try {
          const {data: {tokenInfos}} = await this.$apollo.mutate({
            mutation: gql`mutation ($refreshToken: String!) {
            tokenInfos: userRefreshToken(refreshToken: $refreshToken) {
              access_token
              expires_in
            }
          }`,
            variables: {
              refreshToken
            },
          });
          localStorage.setItem('expires_at', (new Date()).getTime() + tokenInfos.expires_in * 1000);
          await this.$apollo.queries.user.refetch();
          this.triggerRefresh();
        } catch (err) {
          this.shouldRefresh = true;
        }
      },
      async logout() {
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation {
              userLogout
            }`,
          });
          this.$store.dispatch('unsetUser');
          localStorage.clear();
          this.$router.push({path: '/login', query: {referer: this.$route.fullPath}});
        } catch(err) {
          console.error(err);
        }
      },
      refreshBrowser() {
        window.location.reload(true);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LayoutSignedIn.vue